import { render, staticRenderFns } from "./CreateReport.vue?vue&type=template&id=d36b2b72&lang=pug&"
import script from "./CreateReport.vue?vue&type=script&lang=ts&"
export * from "./CreateReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports